export default {
	props:{
		guests: {type:Array, default:()=>{return null;} },
		//array of {bed_code:el.bed_code, person_code:el.person_code, person_qty:el.person_qty, from_age:el.from_age, to_age:el.to_age}
	},
	data(){
		return {
			dx: 2,
			bedCodes:['RB','UNKNOWN','EB','NB'],
			iconsMap:{
				'A' : '<i class="qicon-1">adult</i>',
				'T' : '<i class="qicon-1">child</i>',
				'C' : '<i class="qicon-1">child</i>',
				'I' : '<i class="qicon-1">child</i>',
			}
		}
	},
	watch: {

	},
	computed:{
		cp_guestsGrouped(){
			const map1 = new Map();
			if(this.guests){
				for(let el of this.guests){
					let key = `${el.bed_code}-${el.person_code}-${el.from_age}-${el.to_age}`;
					let tmp = {};
					if(map1.has(key)){
						tmp = map1.get(key);
						tmp.person_qty += parseInt(el.person_qty);
					} else {
						tmp = {bed_code:el.bed_code, person_code:el.person_code, from_age:el.from_age, to_age:el.to_age, person_qty:parseInt(el.person_qty)};
					}
					map1.set(key, tmp);
				}
			}
			return Array.from(map1.values());
		},
		cp_renderIcons(){
			let items = {}; let tooltip=[];
			for(const el of this.cp_guestsGrouped){
				const icon = this.iconsMap[el.person_code];
				const qty = parseInt(el.person_qty);
				if(!icon || !qty) continue;

				const bedCode = el.bed_code ? el.bed_code : 'UNKNOWN';
				if(!items[bedCode]) items[bedCode]=[];

				items[bedCode].push(el.person_qty>this.dx?`<span style="margin-left:3px;">${qty}</span>${icon}`:icon.repeat(qty));

				let tt = [];
				tt.push(this.$tc(el.person_code==='A'?'numAdults':'numChildren', qty));
				if(el.from_age!=null && el.to_age!=null) tt.push(this.$t('onAgeRange', {from_age:el.from_age, to_age:el.to_age}));
				if(bedCode!=='UNKNOWN') tt.push(this.$t('onBed'+bedCode));

				tooltip.push(tt.join(' '));
			}
			tooltip = tooltip.join(', ');

			let html = [];
			for(const bed_code of this.bedCodes){
				if(!items[bed_code]) continue;
				html.push(items[bed_code].join(','));
			}
			html = html.join('+');

			return {tooltip,html};
		},
		hasDefaultSlot () {
			return !!this.$slots.default
		},

	},
	methods: {
	},
	template: `
<qit-simple-tooltip class="guests-icons">
	<template v-slot:activator>
		<span v-html="cp_renderIcons.html"></span>
		<span class="guests-icons-desc" v-if="hasDefaultSlot"><slot></slot></span>
	</template>
	<template v-slot:default>{{cp_renderIcons.tooltip}}</template>
</qit-simple-tooltip>
`,
}
